import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Splashpage.css';
import logo from '../assets/logo.png';
import 'animate.css';
import RightLine from '../assets/rightline.png'
import LeftLine from '../assets/leftline.png'
const SplashPage = () => {
    return (
        <>

<div className="d-flex justify-content-center align-items-center" style={{height:'100vh'}}>
    <div>
  <h2 className='text-center animate__animated animate__fadeInDown'>Currently Under Construction</h2>
  <p className='text-center animate__animated animate__fadeInDown'>We are building something amazing. Stay tuned!</p>
  </div>
</div>
        <div>
        <img src={logo} alt="Logo" className="logo animate__animated animate__fadeIn" />
        </div>

        <div>
            <img src={RightLine} className='ms-auto RightLine'/>
            </div>
          
            <div>
            <img src={LeftLine} className='LeftLine'/>
            </div>
     </>
      
        
    );
};

export default SplashPage;